var map = {
	"./avater.svg": 7980,
	"./back-active.svg": 1577,
	"./carausal-next.svg": 6691,
	"./carausal-previous.svg": 6695,
	"./close.svg": 5837,
	"./face.svg": 5176,
	"./facebook.svg": 3479,
	"./game-filed.svg": 272,
	"./game-filled.svg": 9546,
	"./game-unfilled.svg": 8999,
	"./home-empity.svg": 1441,
	"./home-fill.svg": 5072,
	"./insta.svg": 3676,
	"./instagram.svg": 5373,
	"./logosimple.svg": 7356,
	"./more.svg": 916,
	"./playmask.svg": 3969,
	"./profile-active.svg": 5829,
	"./profileunfilled.svg": 9079,
	"./search.svg": 4343,
	"./tiktok.svg": 5301,
	"./tiktokwhite.svg": 4176,
	"./user.svg": 698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;